import Vue from 'vue';
import Buefy from 'buefy';
import App from './App.vue';
import router from './router';
import store from '@/store/index';
import { registerAuthListener } from '@/auth/auth';
import './registerServiceWorker';
import './assets/styles/global.scss';

// TODO there might be a better way to import font awesome
import '../node_modules/@fortawesome/fontawesome-free/js/all.js';

Vue.config.productionTip = false;

Vue.use(Buefy);
registerAuthListener();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
